// Models
import { createCertificationWebpageProcessDateDefaultModel } from './process-date.store'
import { createCertificationWebpagePersonalDataDefaultModel } from './personal-data.store'
import { createCertificationWebpagePurposeOfAssessmentDefaultModel } from './purpose-of-assessment.store'
import { createCertificationWebpageGeneralProofDefaultModel } from './general-proof.store'
import { createCertificationWebpageRelevantProofDefaultModel } from './relevant-proof.store'
import { createCertificationWebpageSupportDocumentDefaultModel } from './support-document.store'
import { createCertificationWebpageSelfAssessmentDefaultModel } from './self-assessment.store'
import { createCertificationWebpageFinalDefaultModel } from './final.store'

const registration = {
  certificationWebpageProcessDate: createCertificationWebpageProcessDateDefaultModel(),
  certificationWebpagePersonalData: createCertificationWebpagePersonalDataDefaultModel(),
  certificationWebpageGeneralProof: createCertificationWebpageGeneralProofDefaultModel(),
  certificationWebpageRelevantProof: createCertificationWebpageRelevantProofDefaultModel(),
  certificationWebpageSupportDocument: createCertificationWebpageSupportDocumentDefaultModel(),
  certificationWebpagePurposeOfAssessment: createCertificationWebpagePurposeOfAssessmentDefaultModel(),
  certificationWebpageSelfAssessment: createCertificationWebpageSelfAssessmentDefaultModel(),
  certificationWebpageFinal: createCertificationWebpageFinalDefaultModel(),
}

export { registration }
